const styles = {
  appWrapperSx: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  mainContentSx: {
    flex: 1,
    pt: { xs: "56px", md: "64px" },
  },
};

export default styles;
